import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-auto ms-auto text-end mt-1 d-flex" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-4 col-xl-3" }
const _hoisted_5 = { class: "col-6 col-md-4 col-xl-3" }
const _hoisted_6 = { class: "d-flex justify-center items-center" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "mx-2",
  fill: "none",
  stroke: "currentColor",
  style: {"height":"32px","width":"56px"},
  viewBox: "0 0 24 24"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14 5l7 7m0 0l-7 7m7-7H3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card py-2 px-3 lead" }, "Сводки не найдены", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "overflow-hidden"
}
const _hoisted_19 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"670px"}
}
const _hoisted_20 = { class: "table table-bordered" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Дата"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Локомотив (секция)"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Цех (подразделение)"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Конструктив"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "ФИО"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Чел / час"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Примечание"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, "Автор"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_22 = ["rowspan"]
const _hoisted_23 = ["rowspan"]
const _hoisted_24 = ["rowspan"]
const _hoisted_25 = { class: "py-2 px-3" }
const _hoisted_26 = { class: "py-2 px-3 text-end" }
const _hoisted_27 = { class: "py-2 px-3" }
const _hoisted_28 = ["rowspan"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = ["rowspan"]
const _hoisted_31 = { class: "btn btn-sm d-flex justify-content-center align-items-center" }
const _hoisted_32 = { class: "m-3 d-flex justify-content-end" }
const _hoisted_33 = {
  key: 1,
  class: "d-flex justify-content-center py-4 mt-4"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Загрузка...")
], -1)
const _hoisted_35 = [
  _hoisted_34
]

import { reactive, onMounted, watch } from 'vue';
import VPagination from '@hennge/vue3-pagination';
import { DatePicker } from 'v-calendar';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';
import api from '@/api';
import { userStore } from '@/store/userStore';
import { ISummary } from '@/@types/ISummary';
import formatDate from '@/utils/formatDate';
import { useModal } from '@/composables/useModal';
import { IEmployeeTariff } from '@/@types/IEmployeeTariff';

type stateType = {
    rows: ISummary[];
    page: number;
    pagesCount: number;
    isLoading: boolean;
    employeesInSectionJobSummary: Array<IEmployeeTariff['employee']>;
    employeeId: number;
    filterDate: {
        start: string;
        end: string;
    };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionJobSummaryComponent',
  setup(__props) {

const { user } = userStore();
const state: stateType = reactive({
    rows: [],
    page: 1,
    pagesCount: 0,
    isLoading: false,
    employeesInSectionJobSummary: [],
    employeeId: 0,
    filterDate: {
        start: '',
        end: '',
    },
});

async function getSummaries(params = {}, isEmployeesIncludes = true) {
    state.isLoading = true;
    return Promise.all([
        api.sectionJobSummary.get(params).then(({ data }) => {
            state.rows = data.rows;
            state.pagesCount = Math.ceil(data.count / 50);
            state.isLoading = false;
        }),
        ...(isEmployeesIncludes
            ? [
                api.employees.getEmployeesInSectionJobSummary().then((res) => {
                    state.employeesInSectionJobSummary = res.data;
                }),
            ]
            : []),
    ]);
}

onMounted(getSummaries);

function createSummaryHandler() {
    useModal('section_job_summary_modal')
        .open({
            type: 'add',
        })
        .then(() => getSummaries({ page: state.page }));
}

function editSummaryHandler(summary: ISummary, idx: number) {
    useModal('section_job_summary_modal')
        .open({
            type: 'edit',
            summary,
        })
        .then(() => getSummaries({ page: state.page }));
}

function deleteSummaryHandler(idx: number) {
    useModal('confirm_modal')
        .open({
            question: 'Подтвердите удаление сводки',
            ok: 'Да',
            cancel: 'Нет',
        })
        .then((r: any) => api.sectionJobSummary.delete(state.rows[idx].id))
        .then(() => getSummaries({ page: 1 }));
}

function employeeSelectHandler(_employee: IEmployeeTariff['employee']) {
    if (state.employeeId === _employee.id) {
        state.employeeId = 0;
        return;
    }
    state.employeeId = _employee.id;
}

function resetFilterDatesHandler() {
    state.filterDate = {
        start: '',
        end: '',
    };
}

watch(
    () => [state.employeeId, state.filterDate, state.page],
    (v) => {
        if (!state.employeeId && !state.page && !state.filterDate.end && !state.filterDate.start) {
            return;
        }
        getSummaries(
            {
                ...(!!state.employeeId && { employeeId: state.employeeId }),
                ...(typeof state.page === 'number' && { page: state.page }),
                ...(!!state.filterDate.start &&
                    !!state.filterDate.end && {
                    filterStartsAt: state.filterDate.start,
                    filterEndsAt: state.filterDate.end,
                }),
            },
            false,
        );
    },
);

return (_ctx: any,_cache: any) => {
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(user).isMaster || _unref(user).isSuperAdmin || _unref(user).isTechnologist || _unref(user).isHeadOfDepot)
          ? (_openBlock(), _createBlock(_component_button_ui, {
              key: 0,
              "button-class": "btn-primary ms-3 btn-sm",
              onClick: createSummaryHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Создать ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_form_group_ui, {
          label: "Сотрудник",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_select_ui, {
              "item-key": "name",
              options: state.employeesInSectionJobSummary,
              placeholder: "Сотрудник",
              searchable: true,
              values: [state.employeeId],
              onOnSelected: employeeSelectHandler
            }, null, 8, ["options", "values"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_form_group_ui, { label: "Период" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DatePicker), {
              modelValue: state.filterDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.filterDate) = $event)),
              mode: "date",
              range: "",
              timezone: 'Asia/Ashgabat'
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("input", _mergeProps({
                    class: "form-control",
                    placeholder: "С",
                    value: inputValue.start
                  }, _toHandlers(inputEvents.start, true)), null, 16, _hoisted_7),
                  (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("input", _mergeProps({
                      class: "form-control",
                      placeholder: "По",
                      value: inputValue.end
                    }, _toHandlers(inputEvents.end, true)), null, 16, _hoisted_12),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: resetFilterDatesHandler
                    }, " X ")
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (!state.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (!state.rows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("table", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rows, (summary, summaryIdx) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: summary.id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.summaryDetailsPerEmployee, (summaryEmployee, summaryEmployeeIdx) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: summaryEmployee.id
                              }, [
                                (!summaryEmployeeIdx)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      class: "py-2 px-3",
                                      rowspan: summary.summaryDetailsPerEmployee.length
                                    }, _toDisplayString(_unref(formatDate)(summary.happenedAt)), 9, _hoisted_22))
                                  : _createCommentVNode("", true),
                                (!summaryEmployeeIdx)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 1,
                                      class: "py-2 px-3",
                                      rowspan: summary.summaryDetailsPerEmployee.length
                                    }, _toDisplayString(summary?.sectionJob
                                                ? `№${summary.sectionJob.section.loco.number}
                                                ${summary.sectionJob.section.loco.locoModel.name}
                                                (${summary.sectionJob.section.number})`
                                                : ''), 9, _hoisted_23))
                                  : _createCommentVNode("", true),
                                (!summaryEmployeeIdx)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 2,
                                      class: "py-2 px-3",
                                      rowspan: summary.summaryDetailsPerEmployee.length
                                    }, _toDisplayString(summary?.department
                                                ? `${summary.department.name}
                                                (${summary.department.subdivision.name})`
                                                : ''), 9, _hoisted_24))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(summaryEmployee.subgroup.nm) + ".  " + _toDisplayString(summaryEmployee.subgroup.group_name), 1),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["py-2 px-3", {
                                            'bg-warning':
                                                state.employeeId && state.employeeId === summaryEmployee.employeeId,
                                        }])
                                }, _toDisplayString(summaryEmployee.employee.name) + "  (" + _toDisplayString(summaryEmployee.employee.post) + ") ", 3),
                                _createElementVNode("td", _hoisted_26, _toDisplayString(summaryEmployee.hoursWorked), 1),
                                _createElementVNode("td", _hoisted_27, _toDisplayString(summaryEmployee.comment), 1),
                                (!summaryEmployeeIdx)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 3,
                                      class: "py-2 px-3",
                                      rowspan: summary.summaryDetailsPerEmployee.length
                                    }, [
                                      _createTextVNode(" ФИО: " + _toDisplayString(summary?.author?.name ?? '-') + "  ", 1),
                                      _hoisted_29,
                                      _createTextVNode("логин: " + _toDisplayString(summary?.author?.login), 1)
                                    ], 8, _hoisted_28))
                                  : _createCommentVNode("", true),
                                (!summaryEmployeeIdx)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 4,
                                      class: "py-2 px-3",
                                      rowspan: summary.summaryDetailsPerEmployee.length
                                    }, [
                                      (_unref(user).id === summary.userId)
                                        ? (_openBlock(), _createBlock(_component_dropdown_ui, { key: 0 }, {
                                            button: _withCtx(() => [
                                              _createElementVNode("button", _hoisted_31, [
                                                _createVNode(_component_vue_feather, {
                                                  size: "14px",
                                                  type: "more-vertical"
                                                })
                                              ])
                                            ]),
                                            list: _withCtx(() => [
                                              _createVNode(_component_button_ui, {
                                                class: "dropdown-item cursor-pointer",
                                                onClick: ($event: any) => (editSummaryHandler(summary, summaryIdx))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Редактировать ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_button_ui, {
                                                class: "dropdown-item cursor-pointer",
                                                onClick: ($event: any) => (deleteSummaryHandler(summaryIdx))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Удалить ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_30))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_unref(VPagination), {
                        modelValue: state.page,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.page) = $event)),
                        "active-color": "#DCEDFF",
                        class: "pagination",
                        pages: state.pagesCount,
                        "range-size": 1
                      }, null, 8, ["modelValue", "pages"])
                    ])
                  ])
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
    ])
  ], 64))
}
}

})